import CryptoJS from "crypto-js";
const secretKey = "verySecure";
const isProd = process.env.NODE_ENV === "prod";

const SecureLocalStorage = {
  getItem: (key) => {
    // console.log("is Prod: " + isProd);
    if (isProd) {
      // console.log("is Prod: " + isProd);
      // console.log("key: " + key);
      const encryptedData = localStorage.getItem(key);
      if (!encryptedData) return;
      const decryptedData = CryptoJS.AES.decrypt(
        encryptedData || false,
        secretKey
      );
      // console.dir(decryptedData);

      // console.log(
      //   "got decryptedData: " +
      //     JSON.parse(decryptedData.toString(CryptoJS.enc.Utf8))
      // );
      if (decryptedData)
        return JSON.parse(decryptedData.toString(CryptoJS.enc.Utf8));
    }
    // console.log("key: " + key);
    // console.log("got data: " + localStorage.getItem(key));
    return localStorage.getItem(key);
  },
  setItem: (key, value) => {
    if (isProd) {
      const encryptedData = CryptoJS.AES.encrypt(
        JSON.stringify(value),
        secretKey
      ).toString();
      return localStorage.setItem(key, encryptedData);
    }

    return localStorage.setItem(key, value);
  },
  removeItem: (key) => localStorage.removeItem(key),
};

export default SecureLocalStorage;
